/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { Button, filledInputClasses, Grid, Typography } from '@mui/material';
import MainCard from '../../ui-component/cards/MainCard';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import MaterialTable from '@material-table/core';
import { IconDownload, IconUpload, IconListDetails } from '@tabler/icons';
import axiosInstance from '../../axiosInstance';
import { Modal } from 'reactstrap';
import configData from '../../config';

const columns = [
    { title: 'Org Id', field: 'org_id' },
    { title: 'Org Name', field: 'name' },
    { title: 'Industry', field: 'industry' },
    { title: 'Owner Name', field: 'org_owner' }
    // {
    //     title: '',
    //     render: (rowData) => (
    //         <button className="fp_w_alp__vrb__button override" style={{}} onClick={() => handleButtonClick(rowData)}>
    //             Preview File
    //         </button>
    //     )
    // }
    // {
    //      title: "Cummulative Km Run", field: "cummliatve_km",
    //      headerStyle: {
    //           color: 'black', fontWeight: 'bold', backgroundColor: '#ffef99', borderLeft: '1px solid #bcbcbc',
    //           borderRight: '1px solid #bcbcbc', borderTop: '1px solid #bcbcbc',
    //      },
    //      cellStyle: {
    //           textAlign: "left",
    //           backgroundColor: '#ffef99',
    //           color: 'black',
    //           fontSize: '12px',
    //           fontWeight: "bolder",
    //           borderLeft: '1px solid #bcbcbc',
    //           borderRight: '1px solid #bcbcbc'

    //      }
    // },
];

const icons = {
    IconDownload,
    IconUpload,
    IconListDetails
};

const OrgStats = () => {
    const actions = [
        // {
        //     icon: icons.IconDownload,
        //     tooltip: 'Download',
        //     onClick: async (event, rowData) => {
        //         const urlWithoutParams = rowData.file_url.split('?')[0];
        //         const anchor = document.createElement('a');
        //         anchor.href = urlWithoutParams;
        //         anchor.download = getFileNameFromUrl(urlWithoutParams);
        //         anchor.click();
        //     }
        // },
        {
            icon: icons.IconListDetails,
            tooltip: 'View Details',
            onClick: async (event, rowData) => {
                // Trigger file input click
                setTableRowData(rowData);
                document.getElementById('fileInput').click();
                //     await handleUpload(rowData);
            }
        }
    ];

    const [apiData, setAPIData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchOrgData = async () => {
            setLoading(true);
            try {
                // const response = await axiosInstance.get(configData.API_SERVER + '/organization/get_org/');
                const response = await axiosInstance.get(configData.API_SERVER + '/organization/get_org_with_org_owner');
                // const response = await axiosInstance.get('http://127.0.0.1:8000/organization/get_org_with_org_owner');
                console.log(response.data);
                setAPIData(response.data);
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        };

        fetchOrgData()
    }, []);

    const TableData = apiData;

    return (
        <React.Fragment>
            <MainCard style={{ color: ' ' }} title="Organization Stats" secondary={<CardSecondaryAction />}>
                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                        <div style={{ width: '100%', paddingBottom: '25px' }}>
                            <MaterialTable
                                style={{width: '99.9%', }}
                                actions={actions}
                                isLoading={loading}
                                title={'Organiations Data'}
                                columns={columns}
                                data={TableData}
                                options={{
                                    pageSize: 10,
                                    actionsColumnIndex: -1,
                                    search: false,
                                    grouping: false,
                                    columnsButton: false,
                                    paging: true,
                                    showFirstLastPageButtons: false,
                                    filtering: false,
                                    headerStyle: {
                                        backgroundColor: 'rgba(173, 216, 230, 0.281)',
                                        color: 'black',
                                        width: '90vw',
                                        height: '45px',
                                        textAlign: 'left',
                                        fontSize: '13px',
                                        // borderLeft: '1px solid #bcbcbc',
                                        // borderRight: '1px solid #bcbcbc',
                                        // borderTop: '1px solid #bcbcbc'
                                    },
                                    cellStyle: {
                                        textAlign: 'left',
                                        color: 'black',
                                        height: '40px',
                                        fontSize: '13px',
                                        // fontWeight: 'bolder'
                                        // borderLeft: '1px solid #bcbcbc',
                                        // borderRight: '1px solid #bcbcbc',
                                    }
                                }}
                            />
                        </div>
                    </Grid>
                </Grid>


            
            </MainCard>
        </React.Fragment>
    );
};

export default OrgStats;
